// project-imports
import adminPanel from './admin-panel';
import applications from './applications';
import chartsMap from './charts-map';
import formsTables from './forms-tables';
import pages from './pages';
import samplePage from './sample-page';
import affiliateReferralsPage from './affiliate-referrals';
import support from './support';
import widget from './widget';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: []
};

export default menuItems;
